<template>
    <div class=" uk-animation-fade">

        <Seo :canonical="'/'+$t('tshirts').toLowerCase()" :title="$t('tshirts')"/>

        <div class="menu-headline-distance"/>
        <SiteHeadline is-main :headline="$t('tshirts')"
                      :message="$t('coming.soon')"/>


        <LoadingStruct :is-loading="loading" is-animation-disabled>
            <div class="headline-message-distance"/>

        </LoadingStruct>

        <div class="uk-margin-xlarge-top"/>

    </div>
</template>


<script>

import SiteHeadline from "../components/SiteHeadline";
import Seo from "../components/Seo";
import LoadingStruct from "@/components/LoadingStruct.vue";

export default {
    name: 'TShirts',
    components: {
        LoadingStruct,
        Seo,
        SiteHeadline
    },
    data() {
        return {
            loading: false,
        };
    },
    created() {
        if (this.getMode !== "cancelcancer") {
            this.routeTo("")
        }
    },
}

</script>


<style lang="scss" scoped>

</style>
